import React from "react";
import { useContext, useState } from "react";
import { DataContext } from "../../../../../Contexts/dataContext";
import "./filter.scss";

export const ProductFilter = () => {
  const ratingArray = [1, 2, 3, 4];

  let {
    dataDispatch,
    category,
    sortBy,
    priceRange,
    rating,
    activeFilterCategory,
  } = useContext(DataContext);

  const categoryHandler = (category) => {
    if (activeFilterCategory.includes(category)) {
      dataDispatch({
        type: "delete_filter_category",
        payload: category,
      });
    } else {
      dataDispatch({
        type: "add_filter_category",
        payload: category,
      });
    }
  };

  return (
    <div className="filter-container">
      <div className="filter">
        <h3>Filter</h3>
      </div>
      <div className="filter-sort">
        <h4>Sort By</h4>
        <div className="category-label-holder">
          <input
            type="radio"
            id="radio5"
            name="radio"
            checked={sortBy === "lowToHigh"}
            onChange={(e) =>
              dataDispatch({
                type: "filterSortBy",
                payload: "lowToHigh",
              })
            }
          />
          <label htmlFor="radio5">Price - Low to High</label>
        </div>
        <div className="category-label-holder">
          <input
            type="radio"
            id="radio6"
            name="radio"
            checked={sortBy === "HighToLow"}
            onChange={(e) =>
              dataDispatch({
                type: "filterSortBy",
                payload: "HighToLow",
              })
            }
          />
          <label htmlFor="radio6">Price - High to Low</label>
        </div>
      </div>

      <div className="price-range">
          <h4>Price</h4>
        
        <input
          type="range"
          min={1}
          max={1000}
          value={priceRange}
          onChange={(e) => {
            dataDispatch({
              type: "filterPrice",
              payload: e.target.value,
            });
          }}
        />
      </div>
      <div className="filter-category">
        <h4>Category</h4>
        <div className="category">
          {category.map(({ categoryName }) => (
            <li className="category-label-holder" key={categoryName}>
              <label>
                <input
                  type="checkbox"
                  id="checkbox1"
                  name="checkbox"
                  value={categoryName}
                  checked={activeFilterCategory.includes(categoryName)}
                  onChange={() => categoryHandler(categoryName)}
                />
                {categoryName}
              </label>
            </li>
          ))}
        </div>
      </div>
      <div className="filter-rating">
        <h4>Rating</h4>
        <div className="rating">
          {ratingArray.map((rate) => {
            return (
              <li className="category-label-holder" key={rate}>
                <label key={rate}>
                  <input
                    type="radio"
                    name="rating1"
                    value={rate}
                    checked={Number(rating) === rate}
                    onChange={(e) =>
                      dataDispatch({
                        type: "filterRating",
                        payload: e.target.value,
                      })
                    }
                  />
                  {rate} Stars and Above
                </label>
              </li>
            );
          })}
        </div>
      </div>

      <div className="filter-clear">
        <button
          className="btn"
          type="button"
          onClick={(e) =>
            dataDispatch({
              type: "clearFilters",
              payload: "clear",
            })
          }
        >
          Clear
        </button>
      </div>
    </div>
  );
};
